/** localStorage key for JWT (DealCouponz-style persistence without redux-persist). */
export const AUTH_TOKEN_KEY = "coupondealz_token";
